<p-chart
  type="doughnut"
  [data]="data"
  [options]="options"
  [style.background-color]="bgColor" />
